import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FindErrorCodesPipe } from '../../common/pipes/errorFind.pipe';
import { CacheService } from '../../shared/services/cache.service';
import { OrderStatus } from '../enums/order-source-type';
import { OrderService } from '../services/order.service';
import { CacheKey } from '../../shared/constants/cachekey.constants';
@Component({
    selector: 'order-promotion-summary',
    templateUrl: '../templates/template1/views/order-promotion-summary.html',
    styleUrls: [
        '../templates/template1/themes/default/less/order-promotion.less'
    ],
    providers: [FindErrorCodesPipe]
})
export class OrderPromotionSummaryComponent implements OnInit {
    webOrderId: string;
    orderDetails: any = {};
    orderSession: any = {};
    orderStatusId: any = OrderStatus;
    orderStatus: any;

    constructor(private _orderService: OrderService,
        private route: ActivatedRoute,
        private _cacheService: CacheService) {
    }
    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.webOrderId = params['webOrderId'];
        });

        if (this.webOrderId) {
            this.getOrderInformation();
            this.getOrderInfoFromSession();
        }

    }

    /**
    * get order information
    */
    getOrderInformation(): void {
        this._orderService.getOrderDetailsById(this.webOrderId).subscribe((response: any) => {
            this.orderDetails = response;

            if (this.orderDetails) {
                switch (this.orderDetails.orderStatusId) {
                    case this.orderStatusId.Pending: {
                        this.orderStatus = 'PENDING';
                        break;
                    }
                    case this.orderStatusId.Accepted: {
                        this.orderStatus = 'ACCEPTED';
                        break;
                    }
                    case this.orderStatusId.Failed: {
                        this.orderStatus = 'FAILED';
                        break;
                    }
                    case this.orderStatusId.Review_Window: {
                        this.orderStatus = 'REVIEW WINDOW';
                        break;
                    }
                    default: {
                        this.orderStatus = 'PENDING';
                        break;
                    }
                }
            }
        });
    }

    getOrderInfoFromSession() {
        this.orderSession = sessionStorage.getItem(CacheKey.OrderInfo) ? JSON.parse(sessionStorage.getItem(CacheKey.OrderInfo)) : null;
    }

}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-promotion-summary.component.ts